<template>
  <va-card :title="$t('dashboard.table.title')">
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="term"
          :placeholder="$t('tables.searchByName')"
          @input="search"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div>

    <va-data-table
      :fields="mode ? detailedFields : fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >
      <template slot="icon">
        <va-icon name="fa fa-list" color="secondary" />
      </template>
      <template v-slot:posting_date="props">
        {{ props.rowData.posting_date | formatDate }}
      </template>
      <template v-slot:amount="props">
        <div style="text-align: right;">{{ props.rowData.amount | Currency }}</div>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      trans: {},
      loading: false,
      term: null,
      mode: 0,
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),
    }
  },
  created () {
    this.getMiniStatement()
  },
  computed: {
    fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:posting_date',
        title: this.$t('tables.headings.date'),
        width: '30%',
        sortField: 'amount',
      }, {
        name: 'description',
        title: this.$t('tables.headings.description'),
        width: '50%',
      }, {
        name: '__slot:amount',
        title: this.$t('tables.headings.amount'),
        width: '20%',
        sortField: 'amount',
      }]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.trans
      }
      console.log(this.term);
      return this.trans.filter(item => {
        return item.description.toLowerCase().startsWith(this.term.toLowerCase()) || item.amount.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
    getMiniStatement () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}getministatement`, this.userData.user_id, config)
        .then(function (res) {
          res = res.data
          self.trans = res.slice()
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    search: debounce(function (term) {
      console.log(term)
      this.term = term
    }, 400),
  },
}
</script>

<style lang="scss">
</style>
